import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicEmptyPartners({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 240 168"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M133.613 22.039C107.09-6.151 46.573 6.003 25.148 55.407 8.77 93.175 4.082 142.269 42.56 156.424c38.477 14.156 54.874-17.235 136.905-7 56.1 7 60.036-65.246 23.76-76.104-36.274-10.858-44.292-24.369-69.612-51.281z"
          fill="#E9EDFB"
        />
        <path
          d="M226.586 105.414l.024.28c1.887 22.783-12.924 48-47.145 43.73-82.03-10.235-98.428 21.156-136.905 7-20.613-7.583-28.838-25.192-29.514-45.716 36.601 4.468 69.8 14.234 139.208-7.917 34.753-11.091 57.71-7.066 74.332 2.623z"
          fill="#8F9DD6"
          opacity={0.32}
        />
        <circle fill="#F8F9FA" fillRule="nonzero" cx={146.023} cy={27.924} r={1} />
        <circle fill="#F8F9FA" fillRule="nonzero" cx={147.023} cy={27.924} r={1} />
        <circle fill="#F8F9FA" fillRule="nonzero" cx={148.023} cy={27.924} r={1} />
        <g transform="translate(51.601 73.64)">
          <path
            d="M34.442 20.316v.003l-3.013 2.518-20.72 4.603a5.238 5.238 0 103.928 9.712l13.197-2.222a16.193 16.193 0 002.161-.513c.278-.083.553-.177.824-.275a84.296 84.296 0 014.92-14.907l-1.297 1.08z"
            fill="#FFF"
          />
          <path
            d="M29.123 65.03c1.028 8.137 1.79 14.166 2.284 18.087-6.028 1.533-15.127 3.753-25.1 3.371l.416-13.51 22.4-7.949z"
            fill="#999"
          />
          <circle fill="#F89D96" cx={11.872} cy={12.216} r={8.874} />
          <path
            d="M4.917 73.7c2.167 5.058 11.561 8.671 13.729 1.445 1.676-5.585 8.317-7.933 11.247-8.71a1.451 1.451 0 001.033-1.756l-8.19-32.173a11.298 11.298 0 00-7.61-8.006C8.617 22.484 1.753 26.635.65 33.359a49.553 49.553 0 00-.575 5.694C-.604 53.248 3.49 70.369 4.917 73.7z"
            fill="#FFF"
          />
          <path
            d="M54.204 44.716a3.633 3.633 0 00-5.37 1.481L35.98 44.985l3.152 5.923 11.723.243a3.653 3.653 0 003.35-6.435z"
            fill="#F89D96"
          />
          <path
            d="M47.812 51.303c-.309.344-.749.54-1.21.54l-16.779-.384a16.754 16.754 0 01-11.036-4.16l-10.06-8.823a5.237 5.237 0 115.042-9.181L30.43 42.443l16.223 3.126a1.631 1.631 0 011.232 1.404l.333 3.068a1.628 1.628 0 01-.407 1.262z"
            fill="#FFF"
          />
          <path
            d="M5.137 19.474a1.448 1.448 0 002.133-.856l.005-.02c.16-.674.027-1.377-.02-2.068-.046-.69.022-1.45.493-1.958.877-.947 2.437-.445 3.706-.684a3.13 3.13 0 002.435-3.343 4.752 4.752 0 00-.078-.431 2.41 2.41 0 012.502-2.92c1.282.073 2.666.462 3.727-.488a2.749 2.749 0 00.66-2.963c-.606-1.748-2.318-2.663-4.012-3.166A14.676 14.676 0 004.25 2.617c-1.07.755-2.069 1.703-2.525 2.93-.456 1.226-.236 2.774.792 3.584a6.623 6.623 0 00-1.534 6.434c.508 1.636 2.932 3.205 4.155 3.909z"
            fill="#333532"
          />
        </g>
        <path
          d="M122.783 65.268a8.75 8.75 0 01.7 15.637l7.31 3.254a6 6 0 013.04 7.921l-6.508 14.617c-4.492 10.09-16.315 14.629-26.405 10.136l-18.271-8.135a2 2 0 01-1.014-2.64l4.882-10.962a8.75 8.75 0 115.694-12.79l4.067-9.136a4 4 0 015.28-2.027l9.136 4.068a8.75 8.75 0 0112.09-9.943z"
          fill="#8E9FCC"
        />
        <path
          d="M150.973 27.287a8.75 8.75 0 01-1.482 15.582l5.087 3.179a8 8 0 012.545 11.024l-14.837 23.745a6 6 0 01-8.268 1.908l-5.498-3.435a8.75 8.75 0 10-13.913-8.694l-9.422-5.888a2 2 0 01-.636-2.756l5.49-8.783a8.75 8.75 0 118.826-14.124l4.76-7.622a4 4 0 015.512-1.272l8.48 5.298a8.75 8.75 0 0113.356-8.162z"
          fill="#FCC083"
        />
        <g transform="translate(141.685 33.255)">
          <path
            d="M29.122 25.572l-2.397-.015-1.281-.006-7.342-12.835c.062-.134.115-.272.16-.413.817-2.52-1.732-4.225-2.6-4.225-.869 0-1.902.161-2.657.962-.756.8-1.46 3.035.237 4.43.617.508.883.685 1.409.725.309 1.177 1.356 3.418 2.075 5.804.964 3.2 4.958 8.417 5.461 11.733.209.06.421.102.637.127 1.12.1 2.248.062 3.358-.115 1.496-.19 2.91-.458 3.664-.4l-.724-5.772zm-8.485 84.755h-3.696L15.182 96.07h5.456z"
            fill="#F89D96"
          />
          <path d="M14.3 109.874h7.13v4.489H9.811a4.489 4.489 0 014.489-4.489z" fill="#8E9FCC" />
          <path fill="#F89D96" d="M46.868 110.327h-3.696L41.413 96.07h5.456z" />
          <path
            d="M40.532 109.874h7.129v4.489H36.043a4.489 4.489 0 014.489-4.489z"
            fill="#8E9FCC"
          />
          <path
            d="M20.7 101.497c-.04 0-.08-.002-.121-.005l-5.232-.419a1.507 1.507 0 01-1.368-1.743l7.932-49.061.531-6.92a1.499 1.499 0 011.181-1.357l7.979-1.746c.6-.134 1.22.113 1.566.622l1.945 2.843A33.286 33.286 0 0037.6 46.88c1.38 1.572 3.727 5.062 3.938 10.774.056 1.877.251 3.746.583 5.594l6.423 34.601a1.507 1.507 0 01-1.338 1.739l-4.96.375a1.501 1.501 0 01-1.598-1.11L31.85 66.14a.301.301 0 00-.583 0l-9.111 34.237a1.51 1.51 0 01-1.456 1.12z"
            fill="#999"
          />
          <circle fill="#F89D96" cx={34.612} cy={10.607} r={7.405} />
          <path
            d="M22.06 44.462l-.153-10.575c-.564-6.764 2.432-10.315 5.044-12.101a6.006 6.006 0 014.644-.89l5.828 1.26a6.142 6.142 0 013.936 2.804 5.735 5.735 0 01.655 4.525 6.21 6.21 0 01-2.532 3.468c-5.008 3.535-5.36 9.473-5.364 9.532l-.006.123-12.051 1.854z"
            fill="#FDE2EB"
          />
          <path
            d="M5.886 38.279a3.327 3.327 0 01-4.974.144c-2.92-3.063 1.853-7.663 4.785-4.593.103.106.2.219.287.338l14.783-.368 1.764-3.227 5.423 2.106c-1.041 1.614-2.237 7.95-4.96 7.642-.357.01-16.743-2.016-17.108-2.042z"
            fill="#F89D96"
          />
          <path
            d="M25.66 35.837l-4.132-3.033a1.358 1.358 0 01-.29-1.896l5.262-7.17a3.92 3.92 0 116.32 4.637l-5.263 7.17a1.358 1.358 0 01-1.896.292z"
            fill="#FDE2EB"
          />
          <path
            d="M32.812 8.756a12.089 12.089 0 01-3.231.557c-1.097-.013-2.236-.361-2.977-1.17-1.051-1.149-1.037-3.02-.224-4.348.814-1.328 2.276-2.155 3.786-2.534 1.511-.378 3.089-.36 4.646-.34 1.85-1.348 4.546-1.143 6.444.137 1.897 1.279 3.057 3.448 3.55 5.683.492 2.235.384 4.555.198 6.836-.103 1.25.002 2.873 1.196 3.256.754.242 1.568-.201 2.108-.78s.918-1.297 1.482-1.852c1.203-1.182 3.133-1.422 4.723-.857 1.589.565 2.857 1.822 3.75 3.253a11.318 11.318 0 01-12.852 16.837C41.333 32.21 38.255 28.77 36.274 25a27.855 27.855 0 01-3.021-15.805l-.441-.439z"
            fill="#333532"
          />
        </g>
      </g>
    </svg>
  );
}

SvgPicEmptyPartners.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicEmptyPartners.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicEmptyPartners svgRef={ref} {...props} />
));
export default ForwardRef;
